import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	noResolution: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noResolution: {
		id: 'issue-table-grouping.group-row.group-header.resolution-group-header.no-resolution',
		defaultMessage: 'No resolution',
		description: 'Label for grouped items without resolution value',
	},
});
export default messages;
